import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';

import ContentPage from 'components/ContentView/ContentPage/ContentPage';
import useAlerts from 'utils/hooks/useAlerts';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';
import { ResourceType } from 'utils/types';
import { org2trees } from './queries';
import RelationTable from 'components/RelationTable/RelationTable';
import useRelations from 'utils/hooks/useRelations';
import { useRelationData, createRelationQueryData, createOrgOwnerRelationQueryData } from './queries';
import { treeKeys } from 'components/GraphTree/queries';


const OrgToTreesRelations = ({ breadcrumbs }) => {
  const api = useAPI();
  const { orgId } = useParams();
  const [alerts,, addErrorAlert] = useAlerts();

  const [treesQuery, treesRelationQuery, treesOwnerQuery] = useQueries({
    queries: [
      { queryKey: treeKeys.trees(), queryFn: createQueryRequest(api.core.getTrees) },
      { queryKey: org2trees.org(createRelationQueryData(ResourceType.Node, orgId)), queryFn: createQueryRequest(api.core.findRelationships) },
      { queryKey: org2trees.org(createOrgOwnerRelationQueryData(ResourceType.Node)), queryFn: createQueryRequest(api.core.findRelationships) }
    ]
  });

  const trees = useRelationData({
    isLoading: treesQuery.isLoading || treesRelationQuery.isLoading || treesOwnerQuery.isLoading,
    resources: treesQuery.data,
    resourceRelations: treesRelationQuery.data,
    ownedRelations: treesOwnerQuery.data,
    resourceType: ResourceType.Node
  });

  const { updateRelations, deleteRelations } = useRelations({
    refetchFn: treesRelationQuery.refetch,
    queryKey: org2trees.org(createRelationQueryData(ResourceType.Node)),
    onError: addErrorAlert
  });

  return (
    <ContentPage
      breadcrumb={breadcrumbs}
    >
      { alerts }
      <RelationTable
        orgId={orgId}
        resources={trees}
        isLoading={treesQuery.isLoading || treesRelationQuery.isLoading || treesOwnerQuery.isLoading}
        updateRelationsFn={updateRelations.mutate}
        deleteRelationsFn={deleteRelations.mutate}
      />
    </ContentPage>
  );
};

export default OrgToTreesRelations;
